'use strict';

// A couple of lines should generally be enough,
// but let's allow a bit more for edge-cases.
const MAX_REMARKS_LENGTH = 1000;

module.exports = {
  MAX_REMARKS_LENGTH,
};
